
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"2 2 24 24","fill":"none","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"9"}}),_c('path',{attrs:{"d":"M15 13.5h4m-2 0v4m-8-7h6m-3 0v7"}})])
          )
        }
      }
    